import { HighlightOverlayProps } from './highlight-overlay.interface';
import classNames from 'classnames';

const HighlightOverlay: React.FC<HighlightOverlayProps> = ({
  children,
  isHighlighted,
  dimBackground = true,
  overlay,
  className,
}) => {
  if (!isHighlighted) {
    return <>{children}</>;
  }

  return (
    <div
      className={classNames('relative cursor-default', dimBackground && 'z-[60]', className)}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {dimBackground && (
        <div
          className={classNames(
            // Mobile: dim whole screen. Desktop: don't dim the left sidebar (18.5rem).
            'fixed inset-y-0 left-0 right-0 md:left-[18.5rem] bg-brand-default-enabled opacity-30 transition-all duration-500 pointer-events-none'
          )}
        />
      )}
      {overlay}
      {children}
    </div>
  );
};

export default HighlightOverlay;
